<template>
  <div class="container">
    <b-row align-h="start">
      <b-col
        cols="4"
        offset-xl="2"
      >
        <div class="title-div">
          <img
            class="title-bg"
            src="@/assets/images/contact-address-title-bg.png"
          >
          <img
            class="title-ico"
            src="@/assets/images/contact-address-title-ico.png"
          >
          <label class="title-label">新闻动态</label>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col cols="8">
        <div>
          <swiper
            :options="swiperOption"
            class="text-center div-swiper"
          >
            <swiper-slide
              v-for="(slide, index) of swiperArray"
              :key="index"
            >
              <img
                class="img"
                :src="slide.img"
              >
              <p class="p-line">{{ slide.title }}</p>
            </swiper-slide>
            <div
              class="swiper-pagination"
              slot="pagination"
            ></div>
          </swiper>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CompanyNews",
  data() {
    return {
      swiperArray: [
        {
          img: "@/assets/images/company-content-img.png",
          title:
            "最新新闻信息益狐播报:厉害了我的益狐智造科技有限公司的小伙伴们",
        },
        {
          img: "@/assets/images/company-content-img.png",
          title: "最新新闻信息益狐播报",
        },
        {
          img: "@/assets/images/company-content-img.png",
          title: "最新新闻信息益狐播报",
        },
        {
          img: "@/assets/images/company-content-img.png",
          title: "最新新闻信息益狐播报",
        },
        {
          img: "@/assets/images/company-content-img.png",
          title:
            "最新新闻信息益狐播报:厉害了我的益狐智造科技有限公司的小伙伴们",
        },
        {
          img: "@/assets/images/company-content-img.png",
          title:
            "最新新闻信息益狐播报:厉害了我的益狐智造科技有限公司的小伙伴们",
        },
      ],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
};
</script>

<style lang="stylus" scoped>
// .div-title
// width 20.9rem
// height 2.8rem
// background-color #000000
// .p-title
// font-size 1.3rem
// color #ffffff
// line-height 2.8rem
.title-div {
  position: relative;
  margin-top: 5rem;
  width: 100%;
  height: 2.8rem;

  .title-bg {
    height: 2.8rem;
  }

  .title-ico {
    position: absolute;
    height: 1.2rem;
    left: 0.7rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .title-label {
    position: absolute;
    color: #ffffff;
    left: 3.3rem;
    font-size: 1.3rem;
    line-height: 2.8rem;
  }
}

.div-swiper {
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding-bottom: 1rem;

  .swiper-pagination {
    margin-bottom: -1rem;
  }
}

.img {
  width: 100%;
}

.p-line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentNews.vue